import { useBandTutorials, useOrgTutorials } from "../../../app/hooks/useTutorials.js";
import { TutorialsList } from "./TutorialsList.js";

/** Settings › Tutorials for a band seat (the artist audience). */
export function SettingsTutorialsTab() {
  const q = useBandTutorials();
  return <TutorialsList tutorials={q.data} isLoading={q.isLoading} error={q.error} onRetry={() => void q.refetch()} />;
}

/** Settings › Tutorials for an org seat (its org type's audience). */
export function OrgSettingsTutorialsTab() {
  const q = useOrgTutorials();
  return <TutorialsList tutorials={q.data} isLoading={q.isLoading} error={q.error} onRetry={() => void q.refetch()} />;
}
